










import { Vue, Component, Prop, Mixins, Watch } from 'vue-property-decorator'
import CCompetitors from '@/components/CCompetitors/CCompetitors.vue'
import CMarkets from '@/components/CMarkets/CMarkets.vue'
import CPrefix from '@/components/CEventsTableRowPrefix/CEventsTableRowPrefix.vue'
import config from '@/config'
import { EventTypes } from '@altenar/models'

const componentName: string = 'CEventRow'
@Component({
  name: `${componentName}`,
  components: { CPrefix, CMarkets, CCompetitors }
})
export default class UiComponent extends Mixins() {
  @Prop({ default: {} }) public event!: EventTypes.Event
  @Prop({ default: false }) public isLoading!: boolean
  public get score() {
    const score = this.event.Score || ''
    return score ? score.split(':') : ''
  }
  public onEventClick(eventId) {
    config.callbacks.eventclick(eventId)
  }
}
Vue.component(componentName, UiComponent)
